import { motion } from "framer-motion";

import Digitall from "./assets/digital.webp";

const HeroSection = () => {
  return (
    <>
      <section className="w-full bg-[#FAFAFA] py-20 px-4 sm:px-6">
        <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* Left Column – 60% with animation */}
          <motion.div
            className="w-full lg:w-[60%]"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h5 className="text-[#212129] text-sm md:text-[15px] font-semibold uppercase mb-3 tracking-wide">
              Digital Transformation
            </h5>

            <h2 className="text-[#212129] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
              Transforming business
              <br className="hidden sm:block" /> through technology
            </h2>

            <p className="text-[#212129] text-base leading-relaxed max-w-[580px]">
              To increase automation, productivity, and efficiency, a digital
              transformation project entails transferring all data and processes
              into digital formats.
            </p>
          </motion.div>

          {/* Right Column – 40% with animation */}
          <motion.div
            className="w-full lg:w-[40%] flex justify-center"
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >
            <img
              src={Digitall}
              alt="Digital Transformation"
              className="w-454 max-w-[450px] h-auto object-contain"
            />
          </motion.div>
        </div>
      </section>
      <section className="bg-black rounded-[2rem] px-4 py-8 md:px-8 md:py-10 lg:px-12 lg:py-12 text-white font-poppins max-w-5xl mx-auto mt-12 overflow-hidden">
        <div className="text-center">
          <h2
            className="text-2xl md:text-3xl lg:text-5xl font-extrabold mb-4 lg:mb-8
            bg-gradient-to-r from-[#B540FF] via-pink-500 to-[#42E8E0]
            inline-block text-transparent bg-clip-text animate-gradient"
          >
            Overview
          </h2>

          <p className="text-sm md:text-base lg:text-[16px] weight-[400] leading-relaxed max-w-2xl mx-auto whitespace-pre-line">
            LENTERA is a leader in technology innovation and is always looking
            for new ways to improve company processes by implementing digital
            transformation. Digital data formats, including mean, deviation, and
            multiple values, are the subject of our most recent study.
          </p>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
